import { Button, Icon } from '@platform/components';
import AnnouncementCardBG from './announcementcardbg.png';
type CommunityAnnouncementCardProps = {
  link?: string;
  title: string;
  description: string;
  callToAction?: string;
};

export const CommunityAnnouncementCard = (props: CommunityAnnouncementCardProps) => {
  const { link, title, description, callToAction } = { ...props };
  return (
    <div className='ml-4 md:ml-0' data-testid='announcementCard'>
      <div
        className='w-[253px] h-[266px] p-4 rounded-md'
        style={{
          backgroundImage: `url('${AnnouncementCardBG}')`,
          backgroundSize: 'cover',
        }}
      >
        <div className='flex flex-col gap-4 max-h-full h-full'>
          <div className='text-display-xs text-gray-700'>{title}</div>
          <div className='line-clamp-4 text-md'>{description}</div>
          <Button variant='primary' href={link} size='md'>
            {callToAction ?? 'Read More'} <Icon type='arrow-right' />
          </Button>
        </div>
      </div>
    </div>
  );
};
